export const getWebsiteName = (): string => {
  return process.env.SITE_NAME || 'Intranet'
}

export const isProduction = (): boolean => {
  return process.env.BUILD_ENV === 'production'
}

export const isIntranet = (): boolean => {
  return process.env.CLIENT_ID === 'mwm-intranet'
}

export const CLIENT_ID = process.env.CLIENT_ID
